import { useEffect, useContext, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import CustomDialog from '../../components/ui/feedback/CustomDialog.js';
import AssessmentContainerLayout from '../../components/common/AssessmentContainerLayout.js';
import SkeletonAssement from '../../components/assessment/SkeletonAssessment.js';
import LearnosityContainer from '../../components/assessment/LearnosityContainer.js';
import PreviewEventHandler from './PreviewEventHandler.js';
import TimedAutoExitDialog from '../../components/assessment/TimedAutoExitDialog.js';
import { PREVIEW_LAUNCH_ERROR_DIALOG } from '../../components/assessment/LearnosityDialogs.js';
import * as Storage from '../../components/common/Storage.js';

const FormPreview = ({ loginApiCall }) => {
  const {
    learnosityRequestObj,
    openExitingDialog,
    exitingDialogDetails,
    setExit,
    openLaunchErrorDialog,
  } = useContext(AssessmentContext);
  const [, errorWithSetup] = useOutletContext();
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorDialogProps, setErrorDialogProps] = useState();

  useEffect(() => {
    if (!learnosityRequestObj && !errorWithSetup && !openErrorDialog) {
      loginApiCall(setErrorDialogProps, setOpenErrorDialog);
    }
  }, [
    loginApiCall,
    learnosityRequestObj,
    errorWithSetup,
    openErrorDialog,
  ]);

  return (
    <>
      <CustomDialog
        open={openErrorDialog && !errorWithSetup}
        dialogProps={errorDialogProps}
      />
      <TimedAutoExitDialog
        open={openLaunchErrorDialog}
        dialogDetails={PREVIEW_LAUNCH_ERROR_DIALOG()}
        onComplete={() => setExit(true)}
        duration={30}
        storageKey={Storage.STORAGE_LAUNCH_AUTO_EXIT_SECONDS}
      />
      {openExitingDialog && (
        <TimedAutoExitDialog
          open={openExitingDialog}
          dialogDetails={exitingDialogDetails}
          onComplete={() => setExit(true)}
          duration={10}
        />
      )}
      <AssessmentContainerLayout>
        {!learnosityRequestObj && <SkeletonAssement />}
        {learnosityRequestObj && !openErrorDialog && !errorWithSetup && (
          <>
            <PreviewEventHandler />
            <LearnosityContainer />
          </>
        )}
      </AssessmentContainerLayout>
    </>
  );
};

export default FormPreview;
